import { useContext } from "react";
import personIconDark from "../assets/icons/person-dark.svg";
import personIcon from "../assets/icons/person-light.svg";
import luggageIconDark from "../assets/icons/luggage-dark.svg";
import luggageIcon from "../assets/icons/luggage-light.svg";
import poweredByContext from "../store/PoweredByContext";

/**
 * Hook to get passenger and luggage icons based on context and layout.
 * @param {Object} options - Configuration options
 * @param {boolean} [options.isSimple] - Whether using simple styling
 * @param {number} [options.layout] - Layout number (for determining icon style)
 * @param {boolean} [options.isQuotePage] - Whether on /quote page (uses different logic)
 * @returns {Object} Object with passengerIcon and luggageIcon
 */
const useJourneyLegIcons = ({ isSimple, layout, isQuotePage }) => {
    const poweredByCtx = useContext(poweredByContext);
    const raqLayouts = [2, 3, 7];

    const getPassengersIcon = () => {
        if (isQuotePage) {
            return personIconDark;
        } else {
            if (
                isSimple ||
                (poweredByCtx.isPoweredBy && layout && raqLayouts.indexOf(layout) === -1) ||
                (poweredByCtx.isPoweredBy &&
                    poweredByCtx.tenant?.isDarkQuoteModalHeader &&
                    layout &&
                    raqLayouts.indexOf(layout) > -1)
            ) {
                return personIconDark;
            } else {
                return personIcon;
            }
        }
    };

    const getLuggageIcon = () => {
        if (isQuotePage) {
            return luggageIconDark;
        } else {
            if (
                isSimple ||
                (poweredByCtx.isPoweredBy && layout && raqLayouts.indexOf(layout) === -1) ||
                (poweredByCtx.isPoweredBy &&
                    poweredByCtx.tenant?.isDarkQuoteModalHeader &&
                    layout &&
                    raqLayouts.indexOf(layout) > -1)
            ) {
                return luggageIconDark;
            } else {
                return luggageIcon;
            }
        }
    };

    return {
        passengerIcon: getPassengersIcon(),
        luggageIcon: getLuggageIcon(),
    };
};

export default useJourneyLegIcons;
